class StickyBar extends HTMLElement {
  constructor() {
    super();

    this.productID = this.dataset.productId;
    this.target = this.dataset.target;

    document.documentElement.style.setProperty(`${this.dataset.cssVar}`, `${this.offsetHeight}px`);

    this.handleIntersectionObserver();
    this.handleResizeObserver();
  }

  handleIntersectionObserver() {

    const _this = this;
    
    const observer = new IntersectionObserver(function(entries) {
      if(entries[0].boundingClientRect.bottom < 0 ){
        // Element is visible in the screen
        _this.classList.remove('is--hidden');
      }else{
        _this.classList.add('is--hidden');
      }
    }, { threshold: [0] });
    
    observer.observe(document.querySelector(`${ this.target }`));
  }

  handleResizeObserver() {

    const _this = this;

    const observer = new ResizeObserver((entries) => {
      entries.forEach(entry => {
        document.documentElement.style.setProperty(`${_this.dataset.cssVar}`, `${entry.contentRect.height}px`);
      });
    });    
    observer.observe(_this);
  }
}

customElements.define('sticky-bar', StickyBar);